import React, { FC, Fragment } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { OrderDeliveryDetails, OrderDeliveryStatus } from 'models/order';
import { currentUserVar } from 'apollo/reactive-variables/user';

type DeliveryDetailsProps = {
    details: OrderDeliveryDetails;
};
const DeliveryDetails: FC<DeliveryDetailsProps> = ({ details }: DeliveryDetailsProps) => {
    const currentUser = currentUserVar();
    const { t: translate } = useTranslation(['orders']);
    const shouldDisplayDelayed = currentUser.viewSettings?.deliveryDatePassed || false;

    return (
        <Fragment>
            <Box mr={0.5} sx={{ whiteSpace: 'nowrap' }}>
                {details.date ? formatDate(new Date(details.date), 'date') : undefined}
            </Box>
            {details.status === OrderDeliveryStatus.EARLY ? (
                <Typography variant="body2" sx={{ color: 'warning.main' }}>
                    {translate(`DELIVERY_STATUS_EARLY`)}
                </Typography>
            ) : undefined}
            {details.status === OrderDeliveryStatus.DELAYED && shouldDisplayDelayed ? (
                <Typography variant="body2" sx={{ color: 'error.main' }}>
                    {translate(`DELIVERY_STATUS_DELAYED`)}
                </Typography>
            ) : undefined}
        </Fragment>
    );
};

export default DeliveryDetails;
